module.exports = __webpack_public_path__ + "img/car.dda466d5.png";